import React from 'react';
import logo from './logo.svg';
import './App.css';
import Login from "./components/authentication/Login";
import Path from "./route/path";
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';


function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <div>
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <Path>
      <Login/>
      </Path>
      </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
